{
  "title": "biomes",
  "type": "array",
  "uniqueItems": true,
  "items" : {
    "title": "biome",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for a biome",
        "type": "integer",
        "minimum": 0
      },
      "name": {
        "description": "The name of a biome",
        "type": "string"
      },
      "category": {
        "description": "The category of a biome",
        "type": "string"
      },
      "temperature": {
        "description": "An indicator for the temperature in a biome",
        "type": "number",
        "minimum": -1,
        "maximum": 2
      },
      "precipitation": {
        "description": "The type of precipitation: none, rain or snow [before 1.19.4]",
        "type": "string"
      },
      "has_precipitation": {
        "description": "True if a biome has any precipitation (rain or snow) [1.19.4+]",
        "type": "boolean"
      },
      "dimension": {
        "description": "The dimension of a biome: overworld, nether or end",
        "type": "string"
      },
      "displayName": {
        "description": "The display name of a biome",
        "type": "string",
        "pattern": "\\S+"
      },
      "color": {
        "description": "The color in a biome",
        "type": "integer",
        "minimum": 0
      },
      "rainfall": {
        "description": "How much rain there is in a biome [before 1.19.4]",
        "type": "number",
        "minimum": 0,
        "maximum": 1
      }
    },
    "required": [
      "id",
      "name",
      "category",
      "temperature",
      "dimension",
      "displayName",
      "color"
    ]
  }
}
